export class FetchError extends Error {
  constructor(message: string) {
    super(message);
  }
}

type Fetcher<K extends any[], R> = (...args: K) => Promise<R>;

export const controlledFetch = <K extends any[], R extends unknown>(fn: Fetcher<K, R>): Fetcher<K, R> => {
  let promise: Promise<R> | null = null;

  const controlledFetchFn: Fetcher<K, R> = async (...args) => {
    const currentPromise = fn(...args);
    promise = currentPromise;

    return currentPromise.then((result) => {
      if (promise === currentPromise) {
        return result;
      }

      throw new FetchError('Requisição sobrescrita');
    });
  };

  return controlledFetchFn;
};

export const retrieveValidParams = <T extends object>(object: T): Partial<T> => {
  const objectKeys = Object.keys(object);
  const validItems = objectKeys.filter((key) => object[key as keyof T]);

  return validItems.reduce((acc, key) => {
    acc[key as keyof T] = object[key as keyof T];
    return acc;
  }, {} as Partial<T>);
};
